import { useImpersonation } from "@/contexts/ImpersonationContext";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { AlertTriangle, LogOut, User, Building2 } from "lucide-react";
import { toast } from "sonner";

export function ImpersonationBanner() {
  const { isImpersonating, target, endImpersonation } = useImpersonation();
  const { t } = useLanguage();

  if (!isImpersonating || !target) return null;

  const handleEndImpersonation = async () => {
    await endImpersonation();
    toast.success(t("تم إنهاء انتحال الشخصية", "Impersonation ended"));
    // Hard redirect to force full app reload with Super Admin context
    // This ensures React Query cache is cleared and all state is fresh
    window.location.replace("/super-admin");
  };

  return (
    <div className="fixed top-0 start-0 end-0 z-[100] bg-amber-500 text-amber-950 py-2 px-4">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AlertTriangle className="h-5 w-5" />
          <span className="font-semibold">
            {t("وضع انتحال الشخصية", "Impersonation Mode")}
          </span>
          <span className="text-sm opacity-90 flex items-center gap-2">
            <User className="h-4 w-4" />
            {target.fullName}
            <span className="mx-1">•</span>
            <Building2 className="h-4 w-4" />
            {target.companyName}
          </span>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={handleEndImpersonation}
          className="bg-amber-600 border-amber-700 text-white hover:bg-amber-700"
        >
          <LogOut className="h-4 w-4 me-2 rtl:rotate-180" />
          {t("إنهاء الانتحال", "End Impersonation")}
        </Button>
      </div>
    </div>
  );
}
